"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Delete } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type { PurchaseOrderResponse } from "@stocks/shared";

/** 발주 취소 — 삭제가 아니라 CANCELLED 상태로 기록이 보존된다 */
export const useCancelOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) =>
      Delete<PurchaseOrderResponse>(`/v1/purchase-orders/${id}`, {
        data: { reason },
      }),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [orderKeys.orders] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "발주 취소에 실패했습니다."),
  });
};
